import React, { Component } from "react";

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import OrderedSupplier from "./OrderedSupplier.js";
import { Link } from 'react-router-dom';
import '../../Styles/customerForm.css';

class OrderedSupplierList extends Component {
	constructor() {
		super();
	}
	
	render() {
//		console.log("OrderedSupplierList RENDER");
//		console.log(this.props);
		let supplyers=[];
		let i=0;
		this.props.suppliers.forEach((supplier) => {
			if(this.props.users[this.props.supplierConfig[supplier].supplier].enabled){
				//if(this.props.supplierConfig[supplier].supplier)
//				let customerUser = (this.props.supplierConfig[supplier].hasOwnProperty('customerUser')) ? this.props.users[this.props.supplierConfig[supplier].customerUser].username : '';
//				console.log(customerUser);
				supplyers.push(
					<OrderedSupplier
						//id={this.props.supplierConfig[supplier]}
						id={this.props.supplierConfig[supplier].id}
						username={this.props.users[this.props.supplierConfig[supplier].supplier] ? this.props.users[this.props.supplierConfig[supplier].supplier].username : this.props.supplierConfig[supplier].supplier}
						index={i}
						morePriority={this.props.morePriority}
//						customeruser={customerUser}
					/>
				)
				i++;
			}
		});
		return (
			<span className='orderedsupplierlist'>
				{supplyers}
			</span>
		);
	}
}

export default OrderedSupplierList;